import React from "react";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";

export default function AlertDialogProgress(props) {
  const [open, setOpen] = React.useState(!false);
  const [progress, setProgress] = React.useState(props.progress);

  const handleClickOpen = () => {
    setOpen(true);
  };
  React.useEffect(() => {
    setProgress(props.progress);
    if (props.progress === 100) {
      setTimeout(() => {
        setOpen(false);
      }, [3000]);
    }
  }, [props.progress]);
  const handleClose = () => {
    setOpen(false);
  };

  return (
    <div>
      <Dialog
        open={open}
        // onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">{props.title}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            <div className="progress  image-upload-progress-mobile" style={{ minWidth: "450px" }}>
              <div
                className="progress-bar bg-success"
                style={{ width: `${progress}%` }}
              >
                {Math.floor(progress)}% Uploaded{" "}
              </div>
            </div>
          </DialogContentText>
        </DialogContent>
      </Dialog>
    </div>
  );
}
